import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import { NodeTypes, type NodeData } from "@/workflow_api/types/workflow";
import { FormVariables } from "../form";
import { DataCenterVariables } from "../data-center";
import { CalculatedFieldVariables } from "../calculated-field";
import { DocGeneratorVariables } from "../doc-generator";
import { InteroperabilityVariables } from "../interoperability";
import { PaymentVariables } from "../payment";
import { N8NVariables } from "../n8n";
import { SingDocumentVariables } from "../sing-document";
import { ExpedienteVariables } from "../expediente";

interface Props {
  id: string;
}

export const MergeVariables = ({ id }: Props) => {
  const { getNodeById } = useWorkflowStore();
  const mergeNode = getNodeById(id);
  if (!mergeNode) return <></>;

  const data = mergeNode.data as unknown as NodeData;
  const firstEntry = data.inputs?.find((i) => i.type === "MERGE_ENTRY");
  if (!firstEntry) return <></>;

  const entryValue =
    typeof firstEntry.value === "string"
      ? JSON.parse(firstEntry.value)
      : firstEntry.value;
  const entryNodeId = entryValue?.node_id;
  if (!entryNodeId) return <></>;

  const entryNode = getNodeById(entryNodeId);
  if (!entryNode) return <></>;

  const entryNodeType = entryNode.data.type;

  switch (entryNodeType) {
    case NodeTypes.FORM:
      return <FormVariables id={entryNodeId} />;
    case NodeTypes.DATA_CENTER:
      return <DataCenterVariables id={entryNodeId} />;
    case NodeTypes.CALCULATED:
      return <CalculatedFieldVariables id={entryNodeId} />;
    case NodeTypes.DOC_GENERATOR:
      return <DocGeneratorVariables id={entryNodeId} />;
    case NodeTypes.INTEROPERABILITY:
      return <InteroperabilityVariables id={entryNodeId} />;
    case NodeTypes.PAYMENT:
      return <PaymentVariables id={entryNodeId} />;
    case NodeTypes.N8N:
      return <N8NVariables id={entryNodeId} />;
    case NodeTypes.SIGN_DOCUMENT:
      return <SingDocumentVariables id={entryNodeId} />;
    case NodeTypes.EXPEDIENTE:
      return <ExpedienteVariables id={entryNodeId} />;
    case NodeTypes.MERGE:
      return <MergeVariables id={entryNodeId} />;
    default:
      return <></>;
  }
};
